import { render } from "./PreviewOverviewItem.vue?vue&type=template&id=0ee938d5&scoped=true&ts=true"
import script from "./PreviewOverviewItem.vue?vue&type=script&lang=ts"
export * from "./PreviewOverviewItem.vue?vue&type=script&lang=ts"

import "./PreviewOverviewItem.vue?vue&type=style&index=0&id=0ee938d5&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee938d5"]])

export default __exports__